import React, { Component } from 'react';
import Info from './Info.js';
// import Admin from './Admin.js';
import SignIn from './SignIn.js';
import Courier from './Courier.js';
import Catalogue from './Catalogue.js';
import TermsAndConditions from './TermsAndConditions.js';

import db from '../utils/firebase.js';
import { collection, getDocs, query, limit, orderBy, startAfter} from 'firebase/firestore';

import {
	BrowserRouter as Router,
	Switch,
	Route
} from 'react-router-dom'


const COL = "posts";
const PAGE_SIZE = 10;

let finishedRequest = true;

class App extends Component  {

	state = {
		posts: [],
		lastVisiblePost : null,
		hasNextPage : true
	}

	async fetchMorePosts() {
			
		if (this.state.lastVisiblePost) {

			const next = query(collection(db, COL), orderBy("timestamp", "desc"), startAfter(this.state.lastVisiblePost), limit(PAGE_SIZE));
			const snapshots = await getDocs(next);

			const newPosts = snapshots.docs.map(doc => doc.data());
			const lastPost = snapshots.docs[snapshots.docs.length-1];

			if (newPosts.length === 0) {
				this.setState({
					hasNextPage: false
				})
				return ;
			}

			this.setState({ 
				posts: [...this.state.posts, ...newPosts], 
				lastVisiblePost: lastPost
			})

		}


	} // fetchMorePosts()

	async handleScroll(mobileOffSet) {
		const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
		const isAtBottom = scrollHeight - scrollTop <= clientHeight + mobileOffSet;

		if ((isAtBottom) && (window.location.pathname==="/") && (this.state.hasNextPage) && finishedRequest) {

			finishedRequest = false;
			// when we have scrolled to the bottom of the page, fetch some more data from the firestore for the infinite scroll effect 
			await this.fetchMorePosts();
			finishedRequest = true;

		}

	}



	async componentDidMount() {
		// throttle/debounce scroll event for the infinite scroll effect.
		// document.body.addEventListener("touchmove", () => {this.handleScroll()})

		const isMobile = window.screen.orientation.type.includes("portrait");
		const mobileOffSet = isMobile ? 56 : 0
		
		document.addEventListener("scroll", () => this.handleScroll(mobileOffSet));

		document.addEventListener("contextmenu", (event) => {
			event.preventDefault();
		})

		const first = query(collection(db,COL), orderBy("timestamp", "desc"), limit(PAGE_SIZE))
		const snapshots = await getDocs(first);

		const posts = snapshots.docs.map(doc => doc.data())
		const lastVisiblePost = snapshots.docs[snapshots.docs.length-1]

		this.setState({
			posts,
			lastVisiblePost
		})
		// this.fetchMorePosts();
	}

	render() {
		return (
			<Router id="column-container">
				<div id="App" className="column-container">
					<Switch>
						<Route exact path="/"> 
							<Catalogue
								posts={this.state.posts}
							/>
						</Route>
						<Route path="/info">
							<Info/>
						</Route>
						<Route path="/terms_and_conditions" className="column-container">
							<TermsAndConditions/>
						</Route>

						<Route path="/sign_in">
							<SignIn/> 
						</Route> 

						<Route path="/courier">
							<Courier/>
						</Route>
						{/*<Route path="/admin"> 
							<Admin/>
						</Route>*/}
					</Switch>
				</div>
			</Router>
		)
	}
}

export default App;